import React, {useEffect, useState} from 'react'
import RestProvider from 'providers/RestProvider';
import {customStyle} from './RelojStyle'
import {properties} from './RelojData'
import {Grid} from '@material-ui/core';
import {months} from 'AppData';

export default function Reloj() {

    const [date, setDate] = useState('');
    const [time, setTime] = useState('');
    const {crudOperation, crudOperationsType} = RestProvider();
    let dateTime;

    useEffect(() => {
        getServerDateTime();

        //Ejecuta cada x tiempo el metodo indicado
        let interval = setInterval(() => updateDateTime(), properties.ONE_SECOND);

        //Limpiar el intervalo cuando se desmonte el componente
        return (() =>{
            clearInterval(interval)
        })
    }, []) ;

    /*
    * Recuperar la hora del servidor
    */
    const getServerDateTime = async () => {
        crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE, { url:'', method: 'get'}).then(response => {
            initDate(response.data);
        })
    }

    /*
    * Pasar la fecha en el formato que llega del servidor: 09:46:36 18-03-2021
    * al formato Date
    */
    const initDate = (fechaString) =>{  
        let dateAndTime = fechaString.split(properties.DATE_TIME_SEPARATOR);
        let timePart = dateAndTime[0].split(properties.TIME_SEPARATOR)
        let datePart = dateAndTime[1].split(properties.DATE_SEPARATOR)        
        dateTime = new Date(datePart[2], (datePart[1]-1), datePart[0], timePart[0], timePart[1], timePart[2]);
    }

    /*
    * Sumar a la fecha actual un segundo
    * y formatearla con el estilo para mostrarlo
    */
    const updateDateTime = () =>{
        if(dateTime){
            dateTime = new Date (dateTime.setSeconds(dateTime.getSeconds() + 1));
            formatTime();
            formatDate();
        }
    }

    /*
    * Obtener el tiempo en el formato indicado
    * Ejemplo: 09:50:24
    */
    const formatTime = () => {
        setTime(('0' + dateTime.getHours()).slice(-2)+':'+('0' + dateTime.getMinutes()).slice(-2)+':'+('0' + dateTime.getSeconds()).slice(-2));
    }

    /*
    * Obtener el día del año en el formato indicado
    * Ejemplo: 02 Febrero 2020
    */
    const formatDate = () => {       

        let monthIndex = dateTime.getMonth();
        setDate(('0' + dateTime.getDate()).slice(-2) + ' ' + months[monthIndex] + ' ' + dateTime.getFullYear());
    }

    return (
        <Grid container className={customStyle().gridFecha} direction='row' alignItems='center'>
            <Grid item>
                <span className={customStyle().diaTexto}>{date}</span>
            </Grid>
            <Grid item>
                <span className={customStyle().horaTexto}>{time}</span>
            </Grid>    
        </Grid>
    )
}